// extracted by mini-css-extract-plugin
module.exports = {"PostTemplate":"PostListTemplate-module--PostTemplate--1GQEP","Content":"PostListTemplate-module--Content--plgYm"};